(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function readVariants(wrapper) {
    var script = wrapper.querySelector('script[data-cl-lens-color-variants]');
    if (!script) return [];

    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function getCurrentVariantId(wrapper, form) {
    if (form && form.elements && form.elements.id && form.elements.id.value) {
      var fromForm = parseInt(form.elements.id.value, 10);
      if (!isNaN(fromForm)) return fromForm;
    }

    var fromAttr = parseInt(wrapper.getAttribute('data-cl-lens-color-current-variant-id'), 10);
    if (!isNaN(fromAttr)) return fromAttr;

    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    return urlVariant ? parseInt(urlVariant, 10) : null;
  }

  function findVariantByOption(variants, position, newName, currentVariantId) {
    var pos = parseInt(position, 10);
    var optionKey = 'option' + pos;
    var current = null;

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === currentVariantId) {
        current = variants[i];
        break;
      }
    }

    if (!current) current = variants[0];
    if (!current) return null;

    var fallback = null;

    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];

      if (v[optionKey] !== newName) continue;

      var otherOptionsMatch = true;

      for (var p = 1; p <= 3; p++) {
        if (p === pos) continue;

        var k = 'option' + p;

        if ((current[k] || null) !== (v[k] || null)) {
          otherOptionsMatch = false;
          break;
        }
      }

      if (otherOptionsMatch) {
        if (v.available !== false) return v;
        if (!fallback) fallback = v;
      }
    }

    if (fallback) return fallback;

    for (var m = 0; m < variants.length; m++) {
      if (variants[m][optionKey] === newName) return variants[m];
    }

    return null;
  }

  function resolveProductHandle(wrapper) {
    var attr = wrapper.getAttribute('data-cl-lens-color-product-handle');

    if (attr && attr.indexOf('[object') === -1) return attr;

    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function syncVariantIdToForms(sectionId, variantId) {
    document.querySelectorAll('form.shopify-product-form input[name="id"]').forEach(function (input) {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var modal = document.getElementById('cl-lens-modal-' + sectionId);

    if (modal) {
      var modalForm = modal.querySelector('form.shopify-product-form');

      if (modalForm && modalForm.elements && modalForm.elements.id) {
        modalForm.elements.id.value = variantId;
        modalForm.elements.id.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function updateButtons(wrapper, selectedValue) {
    wrapper.querySelectorAll('[data-cl-lens-color-value]').forEach(function (button) {
      var active = button.getAttribute('data-cl-lens-color-value') === selectedValue;

      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var label = wrapper.querySelector('[data-cl-lens-color-selected-label]');
    if (label) label.textContent = selectedValue;
  }

  function updateModalImage(sectionId, variant, fallbackSrc) {
    var modal = document.getElementById('cl-lens-modal-' + sectionId);
    if (!modal) return;

    var img = modal.querySelector('[data-cl-lens-modal-image]');
    if (!img) return;

    var src = fallbackSrc || '';

    if (!src && variant && variant.featured_media && variant.featured_media.preview_image) {
      src = variant.featured_media.preview_image.src;
    }

    if (!src) return;

    img.src = src;
    img.removeAttribute('srcset');
    img.alt = (variant && variant.name) || img.alt || '';
  }

  function moveMainGalleryToVariant(sectionId, variant, fallbackMediaId) {
    var mediaId = fallbackMediaId || '';

    if (!mediaId && variant && variant.featured_media && variant.featured_media.id) {
      mediaId = String(variant.featured_media.id);
    }

    if (!mediaId) return;

    var section = document.getElementById('shopify-section-' + sectionId);
    var gallery = section
      ? section.querySelector('product-gallery')
      : document.querySelector('product-gallery');

    if (!gallery) return;

    var targetMedia =
      gallery.querySelector('[data-media-id="' + mediaId + '"]') ||
      gallery.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]') ||
      gallery.querySelector('[data-media-id$="-' + mediaId + '"]');

    if (!targetMedia) return;

    targetMedia.removeAttribute('hidden');

    var thumbnail =
      gallery.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]') ||
      gallery.querySelector('[data-media-id="' + mediaId + '"] button') ||
      gallery.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"] button') ||
      gallery.querySelector('[data-media-id$="-' + mediaId + '"] button');

    if (thumbnail) {
      thumbnail.click();
      return;
    }

    var carousel = gallery.querySelector('scroll-carousel');

    if (!carousel) {
      targetMedia.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      return;
    }

    var visibleCells = Array.prototype.filter.call(
      carousel.querySelectorAll('.product-gallery__media'),
      function (cell) {
        return !cell.hasAttribute('hidden');
      }
    );

    var index = visibleCells.indexOf(targetMedia);

    if (index >= 0 && typeof carousel.select === 'function') {
      carousel.select(index, { instant: true });
    } else if (index >= 0 && typeof carousel.selectCell === 'function') {
      carousel.selectCell(index, { instant: true });
    } else {
      targetMedia.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
  }

  function updateUrl(variantId) {
    var newUrl = new URL(window.location.href);
    newUrl.searchParams.set('variant', variantId);
    window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
  }

  function rerenderProductSection(productHandle, sectionId, form, newVariant) {
    var url = ROOT + 'products/' + productHandle + '?variant=' + newVariant.id + '&section_id=' + sectionId;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var newContent = document.createRange().createContextualFragment(html);

        form.dispatchEvent(new CustomEvent('product:rerender', {
          detail: {
            htmlFragment: newContent,
            productChange: false
          }
        }));

        form.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            formId: form.id,
            variant: newVariant,
            previousVariant: null
          }
        }));

        if (
          window.Shopify &&
          window.Shopify.PaymentButton &&
          typeof window.Shopify.PaymentButton.init === 'function'
        ) {
          window.Shopify.PaymentButton.init();
        }
      })
      .catch(function (err) {
        if (window.console) {
          console.error('[lens-color-selector] variant rerender failed', err);
        }
      });
  }

  function wireSelector(wrapper) {
    if (wrapper.dataset.clLensColorWired === '1') return;

    wrapper.dataset.clLensColorWired = '1';

    var optionPosition = wrapper.getAttribute('data-cl-lens-color-option-position');
    var productHandle = resolveProductHandle(wrapper);
    var sectionId = wrapper.getAttribute('data-cl-lens-color-section-id');
    var rerender = wrapper.closest('product-rerender');
    var variants = readVariants(wrapper);

    if (!optionPosition || !productHandle || !sectionId || !rerender || !variants.length) return;

    var observeFormId = rerender.getAttribute('observe-form');
    var form = (observeFormId && document.forms[observeFormId]) || rerender.querySelector('form');

    if (!form) return;

    wrapper.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cl-lens-color-value]');
      if (!button) return;

      var newName = button.getAttribute('data-cl-lens-color-option-name') || button.textContent.trim();
      var currentVariantId = getCurrentVariantId(wrapper, form);
      var newVariant = findVariantByOption(variants, optionPosition, newName, currentVariantId);

      if (!newVariant) return;

      wrapper.setAttribute('data-cl-lens-color-current-variant-id', String(newVariant.id));

      updateButtons(wrapper, newName);
      syncVariantIdToForms(sectionId, newVariant.id);
      updateUrl(newVariant.id);

      updateModalImage(
        sectionId,
        newVariant,
        button.getAttribute('data-cl-lens-color-media-src')
      );

      moveMainGalleryToVariant(
        sectionId,
        newVariant,
        button.getAttribute('data-cl-lens-color-media-id')
      );

      rerenderProductSection(productHandle, sectionId, form, newVariant);
    });

    rerender.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var value = variant['option' + optionPosition];
      if (!value) return;

      wrapper.setAttribute('data-cl-lens-color-current-variant-id', String(variant.id));

      updateButtons(wrapper, value);
      syncVariantIdToForms(sectionId, variant.id);
      updateModalImage(sectionId, variant);
      moveMainGalleryToVariant(sectionId, variant);
    });
  }

  function init() {
    document.querySelectorAll('[data-cl-lens-color-selector]').forEach(wireSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();